import { createClient } from '@supabase/supabase-js';

const URL = import.meta.env.VITE_SUPABASE_URL;
const ANON = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(URL, ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'memorymap.session',
    flowType: 'pkce',
  },
  global: {
    // Keep an idle WebSocket warm for realtime — the broadcast is what tells
    // us the manifest just bumped, so latency here is felt.
    headers: { 'X-Client-Info': 'memorymap-web' },
  },
});

export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
